import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, onMounted, toRefs, getCurrentInstance } from "vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import apis from "@/api";
export default {
  components: {
    BreadCrumb
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    let data = reactive({
      loading: false,
      queryParam: {
        name: "",
        eventName: ""
      },
      paginationObj: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      msgList: []
    });
    onMounted(() => {
      loadData();
    });
    const loadData = () => {
      let params = {
        pageNo: data.paginationObj.pageNo,
        pageSize: data.paginationObj.pageSize,
        name: data.queryParam.name,
        eventName: data.queryParam.eventName
      };
      apis.getMessage(params).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.data = {};
          data.msgList = records !== null && records !== void 0 ? records : [];
          data.paginationObj = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {});
    };
    const resetFields = form => {
      proxy.$refs[form].resetFields();
      loadData();
    };
    const submitForm = form => {
      loadData();
    };
    const handleSizeChange = val => {
      data.paginationObj.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.paginationObj.pageNo = val;
      loadData();
    };
    return {
      ...toRefs(data),
      loadData,
      submitForm,
      resetFields,
      handleSizeChange,
      handleCurrentChange
    };
  }
};